import { render, staticRenderFns } from "./regulatoryFooter.vue?vue&type=template&id=7788f20c&scoped=true&"
import script from "./regulatoryFooter.vue?vue&type=script&lang=js&"
export * from "./regulatoryFooter.vue?vue&type=script&lang=js&"
import style0 from "./regulatoryFooter.vue?vue&type=style&index=0&id=7788f20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7788f20c",
  null
  
)

export default component.exports